// test579
(579 && 0);
